import { loadComputerTaskPage } from '#pplx/frontend/apps/ask/spa/ComputerTaskPageRouteShared.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
export const ComputerTaskPageRoute = Dynamic(loadComputerTaskPage, {
    critical: true,
});
//# sourceMappingURL=ComputerTaskPageRoute.js.map